import theme from '../../../lib/theme';

const { media, scale, colors } = theme;

export default () => ({
  container: {
    borderTop: `1px solid ${colors.grey}`,
    padding: `${scale.m} ${scale.xs} 0`,
  },
  innerContainer: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: '1160px',
    alignItems: 'center',
    justifyContent: 'space-between',

    [media.m.up]: {
      flexDirection: 'row',
      alignItems: 'stretch',
    },
  },
  card: {
    textAlign: 'center',
    padding: `${scale.m} 0`,

    img: {
      width: '75%',
      maxWidth: '180px',
    },
  },
});
